import React from 'react';
import classNames from 'classnames';
import WidgetPhotosGridTeaserProps from 'modules/shared/widgets/components/widget-photos-grid-teaser/widget-photos-grid-teaser.props';
import WidgetPhotosGridTeaserDesktopSlider
    from 'modules/shared/widgets/components/widget-photos-grid-teaser/widget-photos-grid-teaser-desktop/components/widget-photos-grid-teaser-desktop-slider';
import WidgetCoupon from 'modules/shared/widgets/shared/widget-coupon';

import './widget-photos-grid-teaser.desktop.scss';

const WidgetPhotosGridTeaserDesktop: React.FC<WidgetPhotosGridTeaserProps> = ({ config, data }) => {
    const shouldCouponBeVisible = (config.coupon || []).some(couponItem => couponItem.text);

    return (
        <div className="w-photos-grid-teaser-d">
            { shouldCouponBeVisible && (
                <div className="w-photos-grid-teaser-d__coupon">
                    <WidgetCoupon coupon={config.coupon}/>
                </div>
            )}
            <div
                className={classNames({
                    'w-photos-grid-teaser-d__slider': true,
                    'w-photos-grid-teaser-d__slider--right': shouldCouponBeVisible
                })}
            >
                <WidgetPhotosGridTeaserDesktopSlider data={data} config={config} isSliderSmall={shouldCouponBeVisible}/>
            </div>
        </div>
    );
};

export default WidgetPhotosGridTeaserDesktop;
